<style>
  .mat-detail-row {
    padding-left: 55px !important;
  }
</style>
<div style="text-align:center;padding-top:10px" *ngIf="screening.length == 0 && isBusy==false" translate>No Screening
  data exists for student</div>
<div *ngIf="screening.length > 0">
  <mat-table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear matSort matSortActive="ScreeningType"
    matSortDirection="asc" aria-label="Screening Data Table">
    <ng-container matColumnDef="More">
      <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate>More</mat-header-cell>
      <mat-cell *matCellDef="let s" style="min-width:68px;max-width:68px;text-align:center;">
        <span aria-label="Expand row for more details">
          <i [ngClass]="checkExpanded(s) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" aria-hidden="true"></i>
        </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ScreeningType">
      <mat-header-cell *matHeaderCellDef mat-sort-header translate>Screening
        <filter class="mat-filter" [data]="angularMatData" columnName="ScreeningType" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let s">{{s.ScreeningType}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="expandRow">
      <td mat-cell *matCellDef="let s;let i = index;" class="mat-detail-card" [attr.colspan]="displayedScreeningColumn.length">
        <div style="text-align:center;" *ngIf="s.Screenings.length == 0" translate>No screening data exists for student</div>
        <div style="width:100%;" *ngIf="s.Screenings.length > 0">
          <app-screening-detail [screeningdetail]="s.Screenings" [screeningId]="s.Id"></app-screening-detail>
        </div>
      </td>
    </ng-container>

    <!-- Row definitions -->
    <mat-header-row *matHeaderRowDef="displayedScreeningColumn"></mat-header-row>
    <mat-row *matRowDef="let row;let i= index; columns: displayedScreeningColumn;" (click)="toggleExpanded(row)"
      (keydown)="rowKeyPress($event, row)" [attr.aria-label]="getScreeningAriaRow(row)"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandRow']" [@detailExpand]="checkExpanded(row)  ? 'expanded' : 'collapsed'"
      style="overflow: hidden" class="mat-detail-row"></mat-row>
  </mat-table>
</div>